import { NavigationProp, ParamListBase } from '@react-navigation/native';

export function getNavigationDepth(
  navigation: NavigationProp<ParamListBase>,
  depth = 0,
): number {
  const parentNavigation = navigation.getParent();

  if (!parentNavigation) {
    return depth;
  }

  const parentState = parentNavigation.getState();

  if (parentState.type !== 'stack') {
    return depth;
  }

  return getNavigationDepth(parentNavigation, depth + 1);
}
